import React from 'react'
import PropTypes from 'prop-types'

import './style.css'

const ThumbnailBox = (props) => {
  return <div className='thumbnail customBox'>
    {props.children}
  </div>
}

ThumbnailBox.propTypes = {
  children: PropTypes.object.isRequired
}

export { ThumbnailBox }



// WEBPACK FOOTER //
// ./src/components/common/ThumbnailBox/ThumbnailBox.js